import { action, observable } from 'mobx'
import { createContext } from 'react'

import { track } from '../utils/analytics'
import { VIEW_MODE_CHANGED } from '../utils/analytics.constants'

import { BaseStore } from './BaseStore'

const INITIAL_STATE = {
  activeView: 'table',
}

const TYPES = {
  activeView: observable,
}

export class DisplayStore extends BaseStore {
  setActiveView = action((view) => {
    const previousView = this.activeView
    if (previousView !== view) {
      track(VIEW_MODE_CHANGED, { view, previous_view: previousView })
    }
    this.activeView = view
  })
}

export const display = new DisplayStore(INITIAL_STATE, TYPES)
export const DisplayStoreContext = createContext(display)
